export default __webpack_public_path__ + "static/workflows-dark-e85a1472c8b534736e63f5b887ba19bf.png";